"use client";

import { Header, Footer } from "@/components/common";

export default function TermsOfUseClient() {
  return (
    <div className="min-h-screen bg-[#212121]">
      <Header />

      {/* Hero */}
      <section className="pt-40 pb-16 bg-[#212121]">
        <div className="container mx-auto px-6 max-w-6xl">
          <h1 className="text-4xl lg:text-5xl font-medium tracking-tight text-[#F8F7F4] mb-4">
            Terms of Use
          </h1>
          <p className="text-lg text-[#A4A4A4]">
            Please read these terms carefully before using our services.
          </p>
          <p className="text-sm text-[#909090] mt-4">
            Last updated: 31 March 2026
          </p>
        </div>
      </section>

      {/* Content */}
      <main className="container mx-auto px-6 max-w-6xl pb-24">
        <div className="space-y-12">
          {/* Introduction */}
          <section>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              By using the Shop Circle Holdings Ltd (trading as Keystone)
              Applications, you are agreeing to be bound by the following terms
              and conditions (&quot;Terms of Use&quot;). You must read, agree to
              and accept all of the terms and conditions contained in the Terms
              of Use, applicable API license agreements, and Privacy Policy (and
              any applicable data protection addendum, or &quot;DPA&quot;).
            </p>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              Your agreement with us includes these Terms of Service, the API
              License Agreement, Privacy Policy and DPA (if applicable). Read
              them all. Collectively they set out your legal obligations and
              requirements when using our services or applications.
            </p>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              These Terms of Use (&quot;Terms&quot;, &quot;Terms of Use&quot;)
              govern your relationship between you and Shop Circle Holdings Ltd
              (trading as Keystone), One Kingdom Street, Paddington Central,
              London W2 6BD, United Kingdom (&quot;Keystone&quot;,
              &quot;us&quot;, &quot;we&quot;, or &quot;our&quot;), a company
              incorporated in England and Wales, in relation to the use of the
              website (the &quot;Service&quot;) as operated by Shop Circle
              Holdings Ltd.
            </p>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              Shop Circle Holdings Ltd reserves the right to update or modify
              these Terms from time to time at its sole discretion. Your
              continued use of the Services after any changes constitutes
              acceptance of the new Terms.
            </p>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              These Terms of Use are applicable to visitors, users, and others
              who access or use the Services, Applications, and others.
            </p>
            <p className="text-base leading-relaxed text-[#A4A4A4]">
              Your access to and use of the Service is conditioned on your
              acceptance of and compliance with these Terms. By accessing or
              using the Service you agree to be bound by these Terms. If you
              disagree with any part of the Terms, then you may not access the
              Services or Applications.
            </p>
          </section>

          <div className="border-t border-[rgba(96,96,96,0.3)]" />

          {/* 1. Our Services and Applications */}
          <section>
            <h2 className="text-2xl font-medium tracking-tight text-[#F8F7F4] mb-4">
              1. Our Services and Applications
            </h2>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              We develop and make available to you applications and services
              which are designed to enhance your e-commerce platform. Our
              e-commerce applications are built to provide additional features
              to your existing e-commerce store. In some cases, our services and
              applications may permit you to receive, sell, and otherwise use
              material which is uploaded by third parties. We can also provide
              detailed, custom tech stack reviews and a variety of other
              e-commerce services.
            </p>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              The specifics of each aspect of the Services (including technical
              details, support and pricing information) are posted on our
              website, as we may amend them from time to time, as well as in any
              applicable statement of work we may issue to you, in respect of
              the Services or Applications.
            </p>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              We make reasonable efforts to explain each Service&apos;s and
              Application&apos;s features to you on our website, but we
              can&apos;t guarantee a Service or Application will look or perform
              exactly like it appears on a demo page. If you have any questions
              about any terms or details of any of our Services or Applications,
              please reach out to us at the contact information below.
            </p>
            <p className="text-base leading-relaxed text-[#A4A4A4]">
              Shop Circle Holdings Ltd shall use commercially reasonable efforts
              to provide technical support for Services or Applications. We are
              not responsible for providing technical support for any
              applications, products, or services provided to you by third
              parties.
            </p>
          </section>

          <div className="border-t border-[rgba(96,96,96,0.3)]" />

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-[#F8F7F4] mb-4">
              2. Shopify Platform
            </h2>
            <p className="text-base leading-relaxed text-[#A4A4A4]">
              The Keystone applications are designed to operate within the
              Shopify e-commerce platform. Your use of the Shopify platform is
              subject to Shopify&apos;s own terms of service and policies. We
              are not responsible for the availability, performance, or policies
              of the Shopify platform. In the event of any conflict between
              these Terms and Shopify&apos;s terms regarding the use of our
              applications, these Terms shall prevail to the extent permitted.
            </p>
          </section>

          <div className="border-t border-[rgba(96,96,96,0.3)]" />

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-[#F8F7F4] mb-4">
              3. Eligibility
            </h2>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              In order to use the Services or Applications, you must:
            </p>
            <ul className="space-y-2 text-base text-[#A4A4A4] list-disc pl-5 mb-6">
              <li>
                be at least eighteen (18) years old and able to legally undergo
                contractual obligations;
              </li>
              <li>agree to these Terms;</li>
              <li>
                provide true, complete, and up-to-date contact and information;
                and
              </li>
              <li>
                not be &ndash; either individually or as part of a group, entity
                or state, subject to UK, EU, US, and UN sanctions, embargoes,
                and bans that prohibit the use of this Service
              </li>
            </ul>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              By using the Service, you represent and warrant that you meet all
              the requirements listed above and that you won&apos;t use the
              Service in a way that violates any laws or regulations. Note that
              by representing and warranting, you are making a legally
              enforceable promise.
            </p>
            <p className="text-base leading-relaxed text-[#A4A4A4]">
              Shop Circle Holdings Ltd may refuse service, close accounts of any
              users, and change eligibility requirements at any time.
            </p>
          </section>

          <div className="border-t border-[rgba(96,96,96,0.3)]" />

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-[#F8F7F4] mb-4">
              4. Subscriptions
            </h2>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              Some parts of the Service are billed on a subscription basis
              (&quot;Plan(s)&quot;). You will be billed in advance on a
              recurring and periodic basis (&quot;Billing Cycle&quot;). Billing
              Cycles are set on a monthly basis, depending on the subscription
              plan you select when purchasing a Subscription. A minimum number
              of Billing Cycles may apply to a Subscription.
            </p>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              At the end of each Billing Cycle, your Subscription will
              automatically renew under the exact same conditions unless you
              cancel it or Shop Circle Holdings Ltd cancels/changes it. You may
              cancel your Subscription renewal either through your online
              account settings page or by contacting Shop Circle Holdings Ltd
              customer support team, taking into account a notice period of at
              least 30 days.
            </p>
            <p className="text-base leading-relaxed text-[#A4A4A4]">
              A valid payment method, including a credit card, Shoppay,
              GooglePay, or ApplePay, is required to process the payment for
              your Subscription. You shall provide Shop Circle Holdings Ltd with
              accurate and complete billing information including full name,
              address, state, zip code, country, telephone number, and a valid
              payment method. By submitting such payment information, you
              automatically authorize Shop Circle Holdings Ltd to charge all
              Subscription fees incurred through your account to any such
              payment instruments.
            </p>
          </section>

          <div className="border-t border-[rgba(96,96,96,0.3)]" />

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-[#F8F7F4] mb-4">
              5. Free Plan
            </h2>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              Shop Circle Holdings Ltd may, at its sole discretion, offer a
              Subscription free of charge (a &quot;Free&quot; plan). You will
              not be charged by Shop Circle Holdings Ltd for using the Free
              plan.
            </p>
            <p className="text-base leading-relaxed text-[#A4A4A4]">
              At any time and without notice, Shop Circle Holdings Ltd reserves
              the right to (i) modify the terms of use of the Free plan offer,
              or (ii) cancel such Free plan offer.
            </p>
          </section>

          <div className="border-t border-[rgba(96,96,96,0.3)]" />

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-[#F8F7F4] mb-4">
              6. Fee Changes
            </h2>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              Shop Circle Holdings Ltd, in its sole discretion and at any time,
              may modify the Subscription fees for the Subscriptions. Any
              Subscription fee change shall become effective at the end of the
              then-current Billing Cycle.
            </p>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              Shop Circle Holdings Ltd shall provide you with reasonable prior
              notice of any change in Subscription fees to give you an
              opportunity to terminate your Subscription before such
              modifications become effective.
            </p>
            <p className="text-base leading-relaxed text-[#A4A4A4]">
              Your continued use of the Service after the modification of the
              Subscription fee comes into effect constitutes your agreement to
              pay the modified Subscription fee amount.
            </p>
          </section>

          <div className="border-t border-[rgba(96,96,96,0.3)]" />

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-[#F8F7F4] mb-4">
              7. Authorized Use of the Service or Application
            </h2>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              You may only use the Service for applicable lawful purposes and in
              a manner consistent with the nature and purpose of Shop Circle
              Holdings Ltd.
            </p>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              The use of our Services for anything other than its intended use
              is strictly prohibited. This shall include, but not be limited to
              the following:
            </p>
            <ul className="space-y-2 text-base text-[#A4A4A4] list-disc pl-5">
              <li>
                Using the service for any unlawful purpose or in violation of
                any applicable law or regulation;
              </li>
              <li>
                Engaging in any conduct that restricts or inhibits any other
                user from using or enjoying the Service;
              </li>
              <li>
                Attempting to interfere with the proper functioning of the
                Service;
              </li>
              <li>
                Using the service to distribute malware, spam, or other harmful
                content;
              </li>
              <li>
                Attempting to access any areas of the Service that you are not
                authorized to access;
              </li>
              <li>
                Using automated means such as bots, scrapers, or spiders to
                access or interact with the service without our express written
                consent;
              </li>
              <li>
                Impersonating any person or entity or falsely claiming an
                affiliation with any person or entity;
              </li>
              <li>
                Collecting, storing, or sharing other users&apos; personal
                information without their consent.
              </li>
            </ul>
          </section>

          <div className="border-t border-[rgba(96,96,96,0.3)]" />

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-[#F8F7F4] mb-4">
              8. Intellectual Property
            </h2>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              The Service and its original content, features and functionality
              are and will remain the exclusive property of Shop Circle Holdings
              Ltd and its licensors. The Service is protected by copyright,
              trademark, and other laws of both the United Kingdom, the European
              Union, and foreign countries. Our trademarks and trade dress may
              not be used in connection with any product or service without the
              prior written consent of Shop Circle Holdings Ltd.
            </p>
            <p className="text-base leading-relaxed text-[#A4A4A4]">
              All intellectual property rights in the Keystone applications,
              including but not limited to software, algorithms, user interface
              designs, documentation, and all improvements, modifications, or
              derivative works thereof, are and shall remain the exclusive
              property of Shop Circle Holdings Ltd. Nothing in these Terms
              grants you any right, title, or interest in our intellectual
              property other than the limited licence to use the Services in
              accordance with these Terms.
            </p>
          </section>

          <div className="border-t border-[rgba(96,96,96,0.3)]" />

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-[#F8F7F4] mb-4">
              9. Links To Other Web Sites
            </h2>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              Our Service may contain links to third-party web sites or services
              that are not owned or controlled by Shop Circle Holdings Ltd.
            </p>
            <p className="text-base leading-relaxed text-[#A4A4A4]">
              Shop Circle Holdings Ltd has no control over, and assumes no
              responsibility for, the content, privacy policies, or practices of
              any third-party web sites or services. You further acknowledge and
              agree that Shop Circle Holdings Ltd shall not be responsible or
              liable, directly or indirectly, for any damage or loss caused or
              alleged to be caused by or in connection with use of or reliance
              on any such content, goods or services available on or through any
              such web sites or services.
            </p>
          </section>

          <div className="border-t border-[rgba(96,96,96,0.3)]" />

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-[#F8F7F4] mb-4">
              10. Termination
            </h2>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              We may terminate or suspend your access to our Service
              immediately, without prior notice or liability, for any reason
              whatsoever, including without limitation if you breach the Terms.
            </p>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              All provisions of the Terms which by their nature should survive
              termination shall survive termination, including, without
              limitation, ownership provisions, warranty disclaimers, indemnity
              and limitations of liability.
            </p>
            <p className="text-base leading-relaxed text-[#A4A4A4]">
              Upon termination of your access to the Services for any reason,
              Shop Circle Holdings Ltd shall, at your written request made
              within thirty (30) days of termination, delete or return all
              personal data processed on your behalf, unless applicable law
              requires continued storage. After such thirty (30) day period,
              Shop Circle Holdings Ltd may delete all such data without further
              notice.
            </p>
          </section>

          <div className="border-t border-[rgba(96,96,96,0.3)]" />

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-[#F8F7F4] mb-4">
              11. Data Protection
            </h2>
            <p className="text-base leading-relaxed text-[#A4A4A4]">
              Shop Circle Holdings Ltd processes personal data in accordance
              with applicable data protection legislation, including the UK GDPR
              (the EU GDPR as retained in UK law by the European Union
              (Withdrawal) Act 2018), the Data Protection Act 2018, and the EU
              GDPR (Regulation (EU) 2016/679). Full details of our data
              processing practices are set out in our Privacy Policy and, where
              applicable, our Data Processing Addendum. By using our Services,
              you acknowledge that you have read and understood our Privacy
              Policy.
            </p>
          </section>

          <div className="border-t border-[rgba(96,96,96,0.3)]" />

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-[#F8F7F4] mb-4">
              12. Limitation Of Liability
            </h2>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              In no event shall Shop Circle Holdings Ltd, nor its directors,
              employees, partners, agents, suppliers, or affiliates, be liable
              for any indirect, incidental, special, consequential or punitive
              damages, including without limitation, loss of profits, data, use,
              goodwill, or other intangible losses.
            </p>
            <p className="text-base leading-relaxed text-[#A4A4A4]">
              Nothing in these Terms shall limit or exclude our liability for:
              (a) death or personal injury caused by our negligence; (b) fraud
              or fraudulent misrepresentation; (c) any other liability that
              cannot be limited or excluded under the laws of England and Wales.
              If you are a consumer, nothing in these Terms affects your
              statutory rights under the Consumer Rights Act 2015 or other
              applicable consumer protection legislation.
            </p>
          </section>

          <div className="border-t border-[rgba(96,96,96,0.3)]" />

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-[#F8F7F4] mb-4">
              13. Disclaimer
            </h2>
            <p className="text-base leading-relaxed text-[#A4A4A4]">
              Your use of the Service is at your sole risk. The Service is
              provided on an &quot;AS IS&quot; and &quot;AS AVAILABLE&quot;
              basis. The Service is provided without warranties of any kind,
              whether express or implied, including, but not limited to, implied
              warranties of merchantability, fitness for a particular purpose,
              non-infringement or course of performance.
            </p>
          </section>

          <div className="border-t border-[rgba(96,96,96,0.3)]" />

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-[#F8F7F4] mb-4">
              14. Governing Law
            </h2>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              These Terms shall be governed and construed in accordance with the
              laws of England and Wales, without regard to its conflict of law
              provisions.
            </p>
            <p className="text-base leading-relaxed text-[#A4A4A4] mb-4">
              Our failure to enforce any right or provision of these Terms shall
              not be considered a waiver of those rights. If any provision of
              these Terms is held to be invalid or unenforceable by a court, the
              remaining provisions of these Terms will remain in effect. These
              Terms constitute the entire agreement between us regarding our
              Service, and supersede and replace any prior agreements we might
              have between us regarding the Service.
            </p>
            <p className="text-base leading-relaxed text-[#A4A4A4]">
              The courts of England and Wales shall have non-exclusive
              jurisdiction to settle any dispute arising out of or in connection
              with these Terms.
            </p>
          </section>

          <div className="border-t border-[rgba(96,96,96,0.3)]" />

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-[#F8F7F4] mb-4">
              15. Changes
            </h2>
            <p className="text-base leading-relaxed text-[#A4A4A4]">
              We reserve the right, at our sole discretion, to modify or replace
              these Terms at any time.
            </p>
          </section>

          <div className="border-t border-[rgba(96,96,96,0.3)]" />

          <section>
            <h2 className="text-2xl font-medium tracking-tight text-[#F8F7F4] mb-4">
              16. Contact Us
            </h2>
            <p className="text-base leading-relaxed text-[#A4A4A4]">
              If you have any questions about these Terms, please contact us at
              info@key-stone.app.
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}
